import Vue from 'vue'
import Router from 'vue-router'
import routeNames from './routes'
import { BASE_URL } from '@/config/environment'

Vue.use(Router)
const routes = [
  {
    path: '/edit/:token',
    name: routeNames.edit.name,
    component: () => import(/* webpackChunkName: 'edit' */ '@/views/EditView.vue'),
    meta: {}
  },
  {
    path: '/:token',
    name: routeNames.main.name,
    component: () => import(/* webpackChunkName: 'main' */ '@/views/MainView.vue'),
    meta: {}
  },
  {
    path: '*',
    redirect: { name: routeNames.main.name }
  }
]

const router = new Router({
  mode: 'history',
  routes
})

export default router
